export default __webpack_public_path__ + "static/media/995.b8774e0d.png";